import React from 'react';

import {
    ChartConsumer,
    Context as ChartContextProps
} from '@ihme/common/web/components/ChartProvider';

import View from './View';

type Props = ChartContextProps & {
    locationId: number;
};

class Highlight extends React.PureComponent<Props> {
    getData = (): {
        locationValue: number;
        lowestLocations: number[];
        highestLocations: number[];
    } => {
        const { columns, records, locationId, isLoadingData } = this.props;
        if (isLoadingData) {
            return {
                locationValue: 0,
                lowestLocations: [],
                highestLocations: [],
            };
        }

        const valueIndex = columns.indexOf('value');
        const locationIndex = columns.indexOf('location_id');

        const selectedLocationValue = records.filter(record =>
            record[locationIndex] === locationId)[0][valueIndex];
        const locations = records
            .sort((a, b) =>
                a[valueIndex] - b[valueIndex])
            .map(record =>
                record[locationIndex]);

        return {
            locationValue: selectedLocationValue,
            lowestLocations: locations.slice(0, 3),
            highestLocations: locations.slice(-3)
                .reverse(),
        };
    };

    render() {
        const { isLoadingData, locationId } = this.props;

        return (
            <View
                {...this.getData()}
                locationId={locationId}
                isLoading={isLoadingData}
            />
        );
    }
}

export default props => (
    <ChartConsumer>
        {consumerProps => <Highlight {...consumerProps} {...props} />}
    </ChartConsumer>
);
